import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
import React, { useContext, useEffect, useState } from 'react';
import Cookie from 'js-cookie';
import { AppBar, Toolbar, IconButton, Container, useMediaQuery, Grid, Popover, TAGLink, TAGTextFieldInput, InputAdornment } from '../../../..';
import { Search, Menu, Close } from '@mui/icons-material';
import AlertBanner from '../../AlertBanner';
import TAGLocation from './LocationBar';
import { useTheme } from '@mui/material/styles';
import { FacilityContext, FacilityActions } from '../../../../contexts';
import { Helmet } from 'react-helmet';

var ADHeader = function ADHeader(props) {
  var _globalThis$localStor;

  var _useState = useState({
    anchorElNav: null,
    showSearchInputField: false,
    searchInputValue: '',
    closestOfficeInfo: {},
    nearByOfficeLocations: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var theme = useTheme();
  var environment = process.env.NODE_ENV === 'development' ? 'nonprod' : 'prod';
  var contentfulData = props.contentfulData;
  var navigationItems = contentfulData.header.navigationLinks;
  var applicationName = contentfulData.name;
  var showFullNav = applicationName !== 'AspenDental - Scheduling';
  var isOfficeDetailsApp = applicationName === 'AspenDental - Office Details';
  var logoUrl = contentfulData.logo.file.url;
  var isMenuOpen = Boolean(state.anchorElNav);
  var isLargeDevice = useMediaQuery('(min-width: 768px)');
  var ENTERPRISE_API_URL = contentfulData.config[environment].ENTERPRISE_API_URL;
  var ALERTS_API_URL = contentfulData.config[environment].ALERTS_API_URL;
  var PROMOTIONS_API_URL = contentfulData.config[environment].PROMOTIONS_AND_OFFERING_API_URL;

  var _useContext = useContext(FacilityContext),
      dispatchFacilityAction = _useContext.dispatch,
      facilityState = _useContext.state;

  var facilityCodeFromStorage = isOfficeDetailsApp && facilityState.code ? facilityState.code : (_globalThis$localStor = globalThis.localStorage) === null || _globalThis$localStor === void 0 ? void 0 : _globalThis$localStor.getItem('facility');
  var apiHeaders = {
    'x-client-application': applicationName
  };
  useEffect(function () {
    if (facilityCodeFromStorage) {
      getOfficeInfo(facilityCodeFromStorage);
    } else {
      var _navigator;

      (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.geolocation.getCurrentPosition(function (position) {
        getNearByOffices(position.coords);
      });
    }
  }, [state.closestOfficeInfo]);

  function getOfficeInfo(_x) {
    return _getOfficeInfo.apply(this, arguments);
  }

  function _getOfficeInfo() {
    _getOfficeInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(facilityCode) {
      var officeInfoResp, officeInfo, alerts, promotions, nearByOfficeLocations, nearByFacilities, facility, _navigator2;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return fetch("".concat(ENTERPRISE_API_URL, "/facilities/").concat(facilityCode), {
                headers: apiHeaders
              });

            case 3:
              officeInfoResp = _context4.sent;
              _context4.next = 6;
              return officeInfoResp.json();

            case 6:
              officeInfo = _context4.sent;

              if (!ALERTS_API_URL) {
                _context4.next = 13;
                break;
              }

              _context4.next = 10;
              return fetch("".concat(ALERTS_API_URL).concat(facilityCode)).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                  var alertsRaw;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return res.json();

                        case 2:
                          alertsRaw = _context.sent;
                          return _context.abrupt("return", alertsRaw.items.map(function (alert) {
                            return {
                              backgroundColor: alert.fields.backgroundColor,
                              content: {
                                raw: JSON.stringify(alert.fields.content)
                              },
                              priority: alert.fields.priority
                            };
                          }));

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }());

            case 10:
              _context4.t0 = _context4.sent;
              _context4.next = 14;
              break;

            case 13:
              _context4.t0 = [];

            case 14:
              alerts = _context4.t0;

              if (!PROMOTIONS_API_URL) {
                _context4.next = 21;
                break;
              }

              _context4.next = 18;
              return fetch("".concat(PROMOTIONS_API_URL).concat(facilityCode)).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(res) {
                  var _promotionsRaw$Entry;

                  var promotionsRaw;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return res.json();

                        case 2:
                          promotionsRaw = _context2.sent;

                          if (!(promotionsRaw !== null && promotionsRaw !== void 0 && (_promotionsRaw$Entry = promotionsRaw.Entry) !== null && _promotionsRaw$Entry !== void 0 && _promotionsRaw$Entry.length)) {
                            _context2.next = 5;
                            break;
                          }

                          return _context2.abrupt("return", promotionsRaw.Entry.map(function (ob) {
                            var _promotionsRaw$includ, _promotionsRaw$includ2;

                            return _objectSpread(_objectSpread({}, ob.fields), {}, {
                              asset: (_promotionsRaw$includ = promotionsRaw.includes['Asset']) !== null && _promotionsRaw$includ !== void 0 && _promotionsRaw$includ.find(function (o) {
                                var _ob$fields, _ob$fields$image, _ob$fields$image$sys, _o$sys;

                                return ((_ob$fields = ob.fields) === null || _ob$fields === void 0 ? void 0 : (_ob$fields$image = _ob$fields.image) === null || _ob$fields$image === void 0 ? void 0 : (_ob$fields$image$sys = _ob$fields$image.sys) === null || _ob$fields$image$sys === void 0 ? void 0 : _ob$fields$image$sys.id) == (o === null || o === void 0 ? void 0 : (_o$sys = o.sys) === null || _o$sys === void 0 ? void 0 : _o$sys.id);
                              }) ? (_promotionsRaw$includ2 = promotionsRaw.includes['Asset']) === null || _promotionsRaw$includ2 === void 0 ? void 0 : _promotionsRaw$includ2.find(function (o) {
                                var _ob$fields2, _ob$fields2$image, _ob$fields2$image$sys, _o$sys2;

                                return ((_ob$fields2 = ob.fields) === null || _ob$fields2 === void 0 ? void 0 : (_ob$fields2$image = _ob$fields2.image) === null || _ob$fields2$image === void 0 ? void 0 : (_ob$fields2$image$sys = _ob$fields2$image.sys) === null || _ob$fields2$image$sys === void 0 ? void 0 : _ob$fields2$image$sys.id) == (o === null || o === void 0 ? void 0 : (_o$sys2 = o.sys) === null || _o$sys2 === void 0 ? void 0 : _o$sys2.id);
                              }) : {}
                            });
                          }));

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 18:
              _context4.t1 = _context4.sent;
              _context4.next = 22;
              break;

            case 21:
              _context4.t1 = [];

            case 22:
              promotions = _context4.t1;
              nearByOfficeLocations = state.nearByOfficeLocations;
              nearByFacilities = nearByOfficeLocations.map(function (facility) {
                return facility.facilityCode;
              });

              if (nearByFacilities.includes(facilityCode)) {
                facility = nearByOfficeLocations.find(function (facility) {
                  return facility.facilityCode === facilityCode;
                });

                if (facility !== null && facility !== void 0 && facility.distance) {
                  dispatchFacilityAction(FacilityActions.setFacilityInfoAction(_objectSpread(_objectSpread({}, officeInfo), {}, {
                    alerts: alerts,
                    promotions: promotions,
                    distance: Math.round(facility.distance)
                  })));
                }
              } else {
                (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(position) {
                    var _position$coords, latitude, longitude, officeDistanceResp, officeDistanceInfo;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _position$coords = position.coords, latitude = _position$coords.latitude, longitude = _position$coords.longitude;
                            _context3.prev = 1;
                            _context3.next = 4;
                            return fetch("".concat(ENTERPRISE_API_URL, "/facility-locations/").concat(facilityCode, "?Latitude=").concat(latitude, "&Longitude=").concat(longitude), {
                              headers: apiHeaders
                            });

                          case 4:
                            officeDistanceResp = _context3.sent;
                            _context3.next = 7;
                            return officeDistanceResp.json();

                          case 7:
                            officeDistanceInfo = _context3.sent;

                            if (officeDistanceInfo.distance) {
                              dispatchFacilityAction(FacilityActions.setFacilityInfoAction(_objectSpread(_objectSpread({}, officeInfo), {}, {
                                alerts: alerts,
                                distance: Math.round(officeDistanceInfo.distance)
                              })));
                            }

                            _context3.next = 14;
                            break;

                          case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3["catch"](1);
                            console.error('Get office distance failed');

                          case 14:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[1, 11]]);
                  }));

                  return function (_x5) {
                    return _ref3.apply(this, arguments);
                  };
                }(), function () {
                  dispatchFacilityAction(FacilityActions.setFacilityInfoAction(_objectSpread(_objectSpread({}, officeInfo), {}, {
                    alerts: alerts,
                    distance: null
                  })));
                });
              }

              _context4.next = 31;
              break;

            case 28:
              _context4.prev = 28;
              _context4.t2 = _context4["catch"](0);
              console.error('Get office details failed');

            case 31:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 28]]);
    }));
    return _getOfficeInfo.apply(this, arguments);
  }

  function getNearByOffices(_x2) {
    return _getNearByOffices.apply(this, arguments);
  }

  function _getNearByOffices() {
    _getNearByOffices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(coords) {
      var latitude, longitude, _globalThis$document, _globalThis$localStor2, response, nearByOfficeLocations;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              latitude = coords.latitude, longitude = coords.longitude;
              _context5.prev = 1;
              _context5.next = 4;
              return fetch("".concat(ENTERPRISE_API_URL, "/facility-locations?Latitude=").concat(latitude, "&Longitude=").concat(longitude), {
                headers: apiHeaders
              });

            case 4:
              response = _context5.sent;
              _context5.next = 7;
              return response.json();

            case 7:
              nearByOfficeLocations = _context5.sent;
              ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.cookie) && Cookie.set('facility', nearByOfficeLocations[0].facilityCode);
              (_globalThis$localStor2 = globalThis.localStorage) === null || _globalThis$localStor2 === void 0 ? void 0 : _globalThis$localStor2.setItem('facility', nearByOfficeLocations[0].facilityCode);
              setState(_objectSpread(_objectSpread({}, state), {}, {
                nearByOfficeLocations: nearByOfficeLocations,
                closestOfficeInfo: nearByOfficeLocations[0]
              }));
              _context5.next = 16;
              break;

            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](1);
              console.error('Offices Request Failed');

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 13]]);
    }));
    return _getNearByOffices.apply(this, arguments);
  }

  var handleOpenNavMenu = function handleOpenNavMenu(event) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElNav: event.currentTarget
    }));
  };

  var handleCloseNavMenu = function handleCloseNavMenu() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElNav: null,
      searchInputValue: ''
    }));
  };

  var handleSearchIconClick = function handleSearchIconClick() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      showSearchInputField: true
    }));
  };

  var handleCloseSearchClick = function handleCloseSearchClick() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      searchInputValue: '',
      showSearchInputField: false
    }));
  };

  var handleSearchInputChange = function handleSearchInputChange(e) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      searchInputValue: e.currentTarget.value
    }));
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 13) {
      return handleStartSearch();
    }
  };

  var handleStartSearch = function handleStartSearch(returnUrl) {
    var searchUrl = contentfulData.header.locationBarFindOfficeUrl;
    var newUrl = new URL(searchUrl);
    var searchParams = newUrl.searchParams; // update search params

    searchParams.set('query', state.searchInputValue);
    searchParams.delete('verticalUrl');
    newUrl.search = searchParams.toString(); // set location url

    if (returnUrl) {
      return newUrl.toString();
    } else {
      globalThis.location.href = newUrl.toString();
    }
  };

  var getTargetUrl = function getTargetUrl() {
    return handleStartSearch(true);
  };

  return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("script", {
    type: "application/ld+json"
  }, "{\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"WebSite\",\n            \"url\": \"https://www.aspendental.com/\",\n            \"potentialAction\": {\n              \"@type\": \"SearchAction\",\n              \"target\": \"".concat(getTargetUrl(), "\"\n            }\n          }"))), React.createElement(AlertBanner, {
    alerts: facilityState.alerts,
    branding: props.branding
  }), React.createElement(AppBar, {
    position: showFullNav ? 'sticky' : 'relative',
    sx: {
      backgroundColor: 'backgrounds.dark',
      height: isLargeDevice ? 88 : 64,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React.createElement(Container, null, React.createElement(Toolbar, {
    disableGutters: true
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: "/"
  }, React.createElement("img", {
    src: logoUrl,
    width: isLargeDevice ? '200px' : '140px',
    height: "unset"
  }))), React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    spacing: 3,
    justifyContent: "flex-end"
  }, isLargeDevice ? React.createElement(React.Fragment, null, state.showSearchInputField ? React.createElement(Grid, {
    item: true,
    sm: 9,
    md: 7,
    xl: 6
  }, React.createElement(TAGTextFieldInput, {
    fieldPlaceHolder: "Search",
    onChange: handleSearchInputChange,
    onKeyDown: handleKeyPress,
    value: state.searchInputValue,
    autoFocus: true,
    sx: {
      borderRadius: 25,
      backgroundColor: '#ecf5fb',
      '& .MuiOutlinedInput-root fieldset': {
        border: 'none'
      }
    },
    endAdornment: React.createElement(InputAdornment, {
      position: "end"
    }, React.createElement(IconButton, {
      onClick: handleCloseSearchClick
    }, React.createElement(Close, null)))
  })) : React.createElement(React.Fragment, null, navigationItems.map(function (navigationItem) {
    return React.createElement(Grid, {
      item: true,
      key: navigationItem.id
    }, React.createElement(TAGLink, {
      variant: "bodyMediumBold",
      key: navigationItem.id,
      href: navigationItem.path,
      color: "neutrals.white"
    }, navigationItem.breadcrumbTitle || navigationItem.title));
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    sx: {
      color: 'inherit'
    },
    onClick: handleSearchIconClick
  }, React.createElement(Search, null))))) : React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "large",
    "aria-label": "account of current user",
    "aria-controls": "menu-appbar",
    "aria-haspopup": "true",
    onClick: handleOpenNavMenu,
    color: "inherit"
  }, isMenuOpen ? React.createElement(Close, null) : React.createElement(Menu, null))))), React.createElement(Popover, {
    id: "menu-appbar",
    anchorEl: state.anchorElNav,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    marginThreshold: 0,
    open: isMenuOpen,
    onClose: handleCloseNavMenu,
    PaperProps: {
      style: {
        width: '100%',
        backgroundColor: theme.palette.backgrounds.dark,
        borderTop: '1px solid',
        borderColor: 'neutrals.dark',
        padding: '35px 16px',
        borderRadius: 0,
        boxShadow: 'none'
      }
    }
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, navigationItems.map(function (navigationItem) {
    return React.createElement(Grid, {
      item: true,
      key: navigationItem.id
    }, React.createElement(TAGLink, {
      variant: "bodyMediumBold",
      key: navigationItem.id,
      href: navigationItem.path,
      color: "neutrals.white"
    }, navigationItem.breadcrumbTitle || navigationItem.title));
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTextFieldInput, {
    fieldPlaceHolder: "Search",
    onChange: handleSearchInputChange,
    onKeyDown: handleKeyPress,
    value: state.searchInputValue,
    sx: {
      '& .MuiOutlinedInput-root': {
        color: 'neutrals.white',
        borderBottom: '1px solid',
        borderColor: 'neutrals.white',
        borderRadius: 0
      },
      '& .MuiOutlinedInput-root input': {
        paddingLeft: 0
      },
      '& .MuiOutlinedInput-root fieldset': {
        border: 'none'
      },
      '& .MuiOutlinedInput-root.Mui-focused fieldset': {
        borderBottom: '1px solid',
        borderColor: 'neutrals.white'
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px'
      }
    },
    endAdornment: React.createElement(InputAdornment, {
      position: "end"
    }, React.createElement(IconButton, {
      onClick: function onClick() {
        return handleStartSearch();
      },
      sx: {
        color: 'neutrals.white'
      }
    }, React.createElement(Search, null)))
  }))))))), showFullNav && React.createElement(TAGLocation, {
    officeInfo: facilityState,
    isLargeDevice: isLargeDevice,
    locationBarData: contentfulData.header,
    applicationName: applicationName
  }));
};

export default ADHeader;